// @flow
import env from '../../environment';
import {getCreator} from '../../http';

export const endpoints = Object.freeze({
  LIST_ORDERS: `${env.baseApiUrl}/im/admin/order`,
  ORDERS_COUNT: `${env.baseApiUrl}/im/admin/order/count`,
  DOWNLOAD_CSV: `${env.baseApiUrl}/im/admin/order/export?format=CSV`,
  LIST_PRE_ORDERS: `${env.baseApiUrl}/im/admin/pre-order`,

  GET_COLLABORATOR_INFO: `${env.baseApiUrl}/usher/user/vendor/store/collaborator/:collaboratorId`,
});

// export type OrderRequest = {
// id?: string,
// };

export const listOrdersApi = getCreator(endpoints.LIST_ORDERS);
export const listPreOrdersApi = getCreator(endpoints.LIST_PRE_ORDERS);
export const ordersCountApi = getCreator(endpoints.ORDERS_COUNT);
export const getCollaboratorInfoApi = getCreator(
  endpoints.GET_COLLABORATOR_INFO
);
